import { useCallback, useEffect } from "react";
import { LogHistory, CreateLogHistory, UpdateLogHistory } from "../types/models/LogHistory.d";
import { UpdateEntityLogHistory } from "../types/models/LogHistory";
import { useGetLogHistoryListQuery, useInsertLogHistoryMutation, useDeleteLogHistoryMutation, } from "../apis/LogHistory.api";
import { useDeleteDialog, useDescriptionAlert } from '../../share';
import { useNavigate } from "react-router";
import { t } from "@lingui/core/macro";

export default function useLogHistory(page: number, pageSize: number) {

    const navigate = useNavigate()
    const { openDialog, closeDialog } = useDeleteDialog();

    const { openSuccessAlert, openFailAlert } = useDescriptionAlert()

    const [insertLogHistoryMutation, { 
        isLoading: insertLogHistoryLoading, 
        isSuccess: insertLogHistoryIsSuccess,
        isError: insertLogHistoryIsError,
        error: insertLogHistoryError,
    }] = useInsertLogHistoryMutation()
    
    const [deleteLogHistoryMutation, { 
        isLoading: deleteLogHistoryLoading,
        isSuccess: deleteLogHistoryIsSuccess,
        isError: deleteLogHistoryIsError,
        error: deleteLogHistoryError,
    }] = useDeleteLogHistoryMutation()

    const loading =
        insertLogHistoryLoading ||
        
        deleteLogHistoryLoading ||
        false

    const insertLogHistory = useCallback(async (logHistory: CreateLogHistory, redirectPath: string|undefined) => {
        try {
            const data = await insertLogHistoryMutation(logHistory).unwrap()
            if (data) {
                if (redirectPath) {
                    if (redirectPath !== '.') {
                        navigate(redirectPath, {relative: 'path'})
                    }
                } else {
                    navigate(`../${data.id}`, {relative: 'path'})
                }
                return data;
            }
        } catch (e) {
            console.log("add error", e)
            openFailAlert(t`Add error: ` + e.toString())
        }
    }, [insertLogHistoryMutation, navigate])
    
    useEffect(() => {
        if (insertLogHistoryIsSuccess) {
            openSuccessAlert('Log History created')
        } else if (insertLogHistoryIsError) {
            console.log("add error", insertLogHistoryError)
            openFailAlert(t`Log History add error: ` + insertLogHistoryError?.data?.message)
        }
    }, [
        insertLogHistoryIsSuccess,
        insertLogHistoryIsError,
        insertLogHistoryError
    ]);

    

    const deleteLogHistory = useCallback((logHistory: LogHistory, redirectPath: string|undefined) => {
        openDialog(async () => {
            logHistory = {
                ...logHistory,
            }
            try {
                const { data } = await deleteLogHistoryMutation(logHistory);
                if (data != null) {
                    if (redirectPath) {
                        navigate(redirectPath, {relative: 'path'})
                    }
                }
            } catch (e) {
                console.log("delete error", e)
                openFailAlert(t`Delete error: ` + e.toString())
            }
            closeDialog()
        });
    }, [deleteLogHistoryMutation, closeDialog, openDialog])
    
    useEffect(() => {
        if (deleteLogHistoryIsSuccess) {
            openSuccessAlert(t`Log History deleted`)
        } else if (deleteLogHistoryIsError) {
            console.log("delete error", deleteLogHistoryError)
            openFailAlert(t`Log History delete error: ` + deleteLogHistoryError?.data?.message)
        }
    }, [
        deleteLogHistoryIsSuccess,
        deleteLogHistoryIsError,
        deleteLogHistoryError
    ]);

    return {
        loading,
        insertLogHistory,
        
        deleteLogHistory
    }
}
